import { memo } from "react";

import { VehicleTypeRow } from "services/api/catalog/vehicles/types/types";

interface VehicleTypeTooltipProps {
  type: VehicleTypeRow;
}

const Row: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="flex justify-between text-sm mb-1">
    <span className="text-slate-300">{label}</span>
    <span className="font-medium text-right max-w-[180px] truncate">{value}</span>
  </div>
);

/**
 * Detalji tipa vozila na hover — slika i podaci koje redak popisa ne stigne pokazati. Isti raspored
 * kao tooltip modela, da se dropdownovi ne razilaze.
 */
const VehicleTypeTooltip: React.FC<VehicleTypeTooltipProps> = ({ type }) => {
  const years =
    type.yearFrom && type.yearTo
      ? `${type.yearFrom} - ${type.yearTo}`
      : type.yearFrom
        ? `${type.yearFrom} -`
        : null;

  const power =
    type.maximumPowerKw && type.maximumPowerHp
      ? `${type.maximumPowerKw} kW / ${type.maximumPowerHp} KS`
      : type.maximumPowerKw
        ? `${type.maximumPowerKw} kW`
        : type.maximumPowerHp
          ? `${type.maximumPowerHp} KS`
          : null;

  return (
    <div className="min-w-[260px]">
      {type.image && (
        <div className="mb-3 rounded overflow-hidden bg-white">
          <img
            src={type.image}
            alt={type.name}
            className="w-full h-[120px] object-contain"
          />
        </div>
      )}

      <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">
        Detalji tipa
      </div>

      <Row label="Tip" value={type.name} />
      {type.manufacturerCode && <Row label="Oznaka" value={type.manufacturerCode} />}
      {type.engine && <Row label="Motor" value={type.engine} />}
      {power && <Row label="Snaga" value={power} />}
      {type.fuelType?.name && <Row label="Gorivo" value={type.fuelType.name} />}
      {type.transmission?.name && <Row label="Mjenjač" value={type.transmission.name} />}
      {type.drivenWheels?.name && <Row label="Pogon" value={type.drivenWheels.name} />}
      {type.cylinderCapacity && <Row label="Obujam" value={`${type.cylinderCapacity} cm³`} />}
      {type.numberOfDoors && <Row label="Vrata" value={type.numberOfDoors} />}
      {type.seats && <Row label="Sjedala" value={type.seats} />}
      {type.co2 && <Row label="CO₂" value={`${type.co2} g/km`} />}
      {years && <Row label="Proizvodnja" value={years} />}
    </div>
  );
};

export default memo(VehicleTypeTooltip);
